import * as z from "zod";

export const reconnectFaireIntegration = {
  name: "reconnectFaireIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
